fbCompileDirective.$inject = ['$compile', '$timeout'];

export default function fbCompileDirective($compile, $timeout) {
  return {
    restrict: 'A',
    scope: false,
    require: '^^?ecFormBuilder',
    link,
  };

  function link(scope, element, attrs, ecFormBuilderController) {
    let childScope;
    let touchedElements = [];
    const elem = element[0];
    const sectionName = elem.getAttribute('fb-compile-name');
    const unbind = scope.$watch(attrs.fbCompile, bool => (bool ? compile() : destroy()));
    //
    scope.$on('$destroy', unbind);

    /////////////////////////////////////////////////////////////////////////////

    function compile() {
      childScope = scope.$new(false, scope);
      elem.innerHTML = ecFormBuilderController.sections[sectionName];
      $compile(element.contents())(childScope);
      $timeout(() => {
        setElementsTouched();
        elem.style.height = 'auto';
      });
    }

    function destroy() {
      touchedElements = getElementsTouched();
      elem.removeAttribute('ec-loader');
      elem.style.height = `${elem.getBoundingClientRect().height}px`;
      childScope && childScope.$destroy();
      $timeout(() => (elem.innerHTML = ''));
    }

    function getElementsTouched() {
      const touchedElementsTemp = [];
      const elemsTouched = [...elem.querySelectorAll('.ng-touched')];

      elemsTouched.forEach(elemTouched => {
        const model = elemTouched.getAttribute('data-ng-model') || elemTouched.getAttribute('ng-model');
        if (model) {
          touchedElementsTemp.push(model);
        }
      });
      return touchedElementsTemp;
    }

    function setElementsTouched() {
      touchedElements.forEach(touchElement => {
        const elToucheds = [...elem.querySelectorAll(`[data-ng-model="${touchElement}"], [ng-model="${touchElement}"]`)];
        if (elToucheds && elToucheds.length) {
          elToucheds.forEach(elTouched => {
            elTouched.classList.add('ng-touched');
            elTouched.classList.remove('ng-untouched');
          });
        }
      });
    }
  }
}
